import { getTailwindColor } from '@/utils/tailwindColors'

const donutColors: string[] = [
    getTailwindColor('red', '300'),
    getTailwindColor('green', '300'),
    getTailwindColor('blue', '300'),
    getTailwindColor('yellow', '300'),
    getTailwindColor('orange', '300'),
    getTailwindColor('purple', '300'),
    getTailwindColor('pink', '300'),
]

export const getDonutColor = (index: number): string =>
    donutColors[index % donutColors.length]
